export default "__VITE_ASSET__CYfqaSxF__"